var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('b-card', [_c('b-tabs', {
    attrs: {
      "pills": "",
      "horizontal": _vm.windowWidth < 768,
      "vertical": _vm.windowWidth > 768,
      "nav-wrapper-class": _vm.windowWidth > 768 ? 'w-25' : 'w-100',
      "fill": ""
    }
  }, [_c('DadosGerais'), _c('Veiculos'), _c('Carga'), _c('Viagem'), _c('Documentos'), _c('Seguro'), _c('Pedagio')], 1), _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm.canSaveNfe ? _c('div', [_c('div', {
    staticClass: "form mb-5"
  }, [_c('button', {
    staticClass: "btn btn-secondary font-weight-bold mr-4",
    on: {
      "click": _vm.handlePrevious
    }
  }, [_vm._v(" Anterior ")]), _c('button', {
    ref: "submit_nova_mdfe",
    staticClass: "btn btn-primary font-weight-bold",
    on: {
      "click": function click($event) {
        return _vm.salvarMdfe(false);
      }
    }
  }, [_vm._v(" Salvar ")]), _c('button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modalTransmitirNfe",
      modifiers: {
        "modalTransmitirNfe": true
      }
    }],
    ref: "transmitir_nova_mdfe",
    staticClass: "btn btn-secondary font-weight-bold mx-2",
    on: {
      "click": function click($event) {
        return _vm.salvarMdfe(true);
      }
    }
  }, [_vm._v(" Transmitir ")]), _c('router-link', {
    staticClass: "btn btn-clean font-weight-bold",
    attrs: {
      "to": {
        name: 'mdfe'
      }
    }
  }, [_vm._v(" Cancelar ")])], 1)]) : _c('div', [_c('button', {
    staticClass: "btn btn-secondary font-weight-bold mr-4",
    attrs: {
      "disabled": _vm.store.currentTab === 0
    },
    on: {
      "click": _vm.handlePrevious
    }
  }, [_vm._v(" Anterior ")]), _c('button', {
    staticClass: "btn btn-primary font-weight-bold",
    on: {
      "click": _vm.handleNext
    }
  }, [_vm._v(" Proximo ")]), _c('router-link', {
    staticClass: "btn btn-clean font-weight-bold",
    attrs: {
      "to": {
        name: 'mdfe'
      }
    },
    on: {
      "click": function click() {
        _vm.store.dataFetched = false;
      }
    }
  }, [_vm._v(" Cancelar ")])], 1)])])])], 1)], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };